import React from 'react';
import { motion } from 'framer-motion';
interface GoldButtonProps {
  children: ReactNode;
  onClick?: () => void;
  href?: string;
  className?: string;
}
export function GoldButton({
  children,
  onClick,
  href,
  className = ''
}: GoldButtonProps) {
  const baseClasses = `
    inline-block px-8 py-4 
    bg-[#c9a04e] text-[#1a2332] 
    font-serif text-xl md:text-2xl tracking-wide
    rounded-sm shadow-[0_0_15px_rgba(201,160,78,0.3)]
    hover:brightness-110 transition-all duration-300
    text-center cursor-pointer
    ${className}
  `;
  const content = <motion.span animate={{
    boxShadow: ['0 0 0px rgba(201,160,78,0)', '0 0 20px rgba(201,160,78,0.4)', '0 0 0px rgba(201,160,78,0)']
  }} transition={{
    duration: 3,
    repeat: Infinity,
    ease: 'easeInOut'
  }} className={baseClasses} data-id="element-221">
      {children}
    </motion.span>;
  if (href) {
    return <a href={href} className="inline-block no-underline" onClick={e => {
      if (onClick) {
        e.preventDefault();
        onClick();
        setTimeout(() => {
          window.location.href = href;
        }, 350);
      }
    }} data-id="element-222">
        {content}
      </a>;
  }
  return <button onClick={onClick} className="border-none bg-transparent p-0" data-id="element-223">
      {content}
    </button>;
}